import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { formatErr } from "../lib/api";
import { Crown } from "lucide-react";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await register(form.name, form.email, form.password);
            toast.success(`Welcome to the Kingdom, ${u.name}`);
            navigate("/dashboard");
        } catch (err) {
            toast.error(formatErr(err));
        } finally { setLoading(false); }
    };

    return (
        <div data-testid="register-page" className="min-h-[80vh] grid place-items-center px-5 py-16 grain">
            <div className="w-full max-w-md card-flat p-8">
                <Crown className="text-gold" size={28} />
                <h1 className="h-display text-4xl mt-4">Join the Kingdom</h1>
                <p className="text-ink text-sm mt-2">Become a Purple Kings fan member.</p>

                <form onSubmit={submit} className="space-y-4 mt-7">
                    <div>
                        <label className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">Name</label>
                        <input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full mt-2 px-4 py-3 text-sm" />
                    </div>
                    <div>
                        <label className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">Email</label>
                        <input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full mt-2 px-4 py-3 text-sm" />
                    </div>
                    <div>
                        <label className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">Password (min 6)</label>
                        <input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full mt-2 px-4 py-3 text-sm" />
                    </div>
                    <button type="submit" disabled={loading} data-testid="reg-submit" className="btn-gold w-full py-4 text-xs disabled:opacity-60">
                        {loading ? "Creating…" : "Create Account"}
                    </button>
                </form>

                <div className="text-center mt-6 text-sm text-ink">
                    Already a king? <Link to="/login" className="text-gold hover:text-gold-bright" data-testid="reg-login-link">Sign In</Link>
                </div>
            </div>
        </div>
    );
}
